import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useMasterContext } from '&/master';
import { useTerritories } from '../../../settings/territories/hooks/use-territories';
import { useLocations } from '../../../settings/locations/hooks/use-locations';
import { ResultsList } from './results-list';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface JumpToResultsProps {
  onClose: () => void;
  query: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function JumpToResults({ onClose, query }: JumpToResultsProps): React.JSX.Element {
  const { t } = useTranslation('common');
  const { territoryId } = useMasterContext();
  const { data: territoriesData, isLoading: isTerritoriesLoading } = useTerritories({
    enabled: query.length > 0,
    name: query,
    page: 1,
    pageSize: 3,
  });
  const { data: locationsData, isLoading: isLocationsLoading } = useLocations({
    enabled: query.length > 0,
    name: query,
    page: 1,
    pageSize: 3,
    territoryIds: territoryId ? [territoryId] : undefined,
  });

  const territories = territoriesData?.items ?? [];
  const locations = locationsData?.items ?? [];
  const isLoading = isTerritoriesLoading || isLocationsLoading;
  const isEmpty = territories.length === 0 && locations.length === 0;

  if (isLoading) {
    return (
      <div className="px-3 py-4">
        <span className="text-sm text-muted-foreground">{t('mainSelector.searching')}</span>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="px-3 py-4">
        <span className="text-sm text-muted-foreground">{t('mainSelector.noResults')}</span>
      </div>
    );
  }

  return <ResultsList locations={locations} onClose={onClose} territories={territories} />;
}
